import React, { useEffect, useRef } from 'react';
import { ToastCollection } from '@els/els-react--toast';
import ToastCollectionService from './ToastCollectionService';

export default function ToastCollectionHost() {
  const collectionRef = useRef(null);

  useEffect(() => {
    ToastCollectionService.setCollectionRef(collectionRef.current);

    return () => {
      ToastCollectionService.reset();
    };
  }, []);

  return <ToastCollection ref={collectionRef} />;
}
